import { render, staticRenderFns } from "./IndustrialFactory.vue?vue&type=template&id=47a6b6a1&scoped=true&"
import script from "./IndustrialFactory.vue?vue&type=script&lang=ts&"
export * from "./IndustrialFactory.vue?vue&type=script&lang=ts&"
import style0 from "./IndustrialFactory.vue?vue&type=style&index=0&id=47a6b6a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6b6a1",
  null
  
)

export default component.exports